module.exports = __webpack_public_path__ + "9eb9389e449d0620f5e51f9ab728a0e0.png";